let mqttAttemptNumber = 0;

export const formatMqttDate = () => new Date().toISOString();

export const truncatePayload = (payload) => {
  if (!payload) return '';
  const payloadString = typeof payload === 'string' ? payload : JSON.stringify(payload);
  return payloadString.slice(0, 100);
};

export const getMqttAttemptNumber = () => mqttAttemptNumber;

export const incrementMqttAttempt = () => {
  mqttAttemptNumber += 1;
  return mqttAttemptNumber;
};

export const resetMqttAttempt = () => {
  mqttAttemptNumber = 0;
};

export const normalizeEventData = (eventData, dimensions) => {
  const safeEventData = eventData && typeof eventData === 'object' ? eventData : {};
  const normalized = {};
  const defaultValueMap = {
    v_attempt: '1',
    v_host: 'unknown',
    v_topic: 'unknown',
    v_reason: 'Unknown error',
    v_payload: '',
    v_date: new Date().toISOString(),
  };

  dimensions.forEach((dimension) => {
    if (dimension.startsWith('v_')) {
      const value = safeEventData[dimension];
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        normalized[dimension] = String(value);
      } else if (defaultValueMap[dimension] !== undefined) {
        normalized[dimension] = defaultValueMap[dimension];
      }
    }
  });

  return normalized;
};
